import EventsHelper from "../../common/js/eventsHelper";

export class Popup {
    constructor() {
        this.popup = '.fs-popup';
        this.popupContent = '.fs-popup--content';
        this.btnClose = '.fs-popup--close';

        this.classOpen = 'fs--open';
        this.classAnimate = 'fs--animate';

    }

    attachEvents() {
        document.querySelector(this.btnClose).addEventListener('click', this.closePopup)
        document.addEventListener('keydown', this.handleOnEscPress)
    }

    removeEvents() {
        document.querySelector(this.btnClose).removeEventListener('click', this.closePopup)
        document.removeEventListener('keydown', this.handleOnEscPress)
    }

    handleOnEscPress = e => {
        if (e.keyCode == 27) {
            this.closePopup();
        }
    }

    openPopup = () => {
        this.togglePopup();
        EventsHelper.hideScrollBar();
        this.attachEvents();
    }

    closePopup = () => {
        this.togglePopup();
        EventsHelper.returnScrollBar();
        this.removeEvents();
    }

    togglePopup() {
        const popup = document.querySelector(this.popup);
        const popupContent = popup.querySelector(this.popupContent);

        popup.classList.toggle(this.classOpen);
        popupContent.classList.toggle(this.classAnimate);
    }
}